<span
  *ngIf="
    !userFirstName &&
    !teamName &&
    !isNews &&
    !isAdminOrganizationDetail &&
    !logEntry &&
    !importsLink &&
    !errorMessageLink
  "
  class="status-element"
  >{{ params.value === true ? 'Yes' : 'No' }}</span
>

<!-- Email verification section -->
<ng-container
  *ngIf="
    !userFirstName &&
    !teamName &&
    !isNews &&
    !isAdminOrganizationDetail &&
    !logEntry &&
    !importsLink &&
    !errorMessageLink &&
    params.from != 'reviewer' &&
    params.from != 'activation'
  "
>
  <ng-container *ngIf="!params.data?.isActivated">
    <a href="javascript:void(0)" id="resendMail" class="emailStatus" (click)="resendUserEmail()"
      >Resend</a
    >
    <a href="javascript:void(0)" id="resendMail" class="emailStatus" (click)="verifyUserEmail()"
      >Verify</a
    >
  </ng-container>
</ng-container>

<!-- User activation section -->
<ng-container
  *ngIf="
    !userFirstName &&
    !teamName &&
    !isNews &&
    !isAdminOrganizationDetail &&
    !logEntry &&
    !importsLink &&
    !errorMessageLink &&
    params.from == 'activation'
  "
>
  <ng-container *ngIf="!params.data?.isActive">
    <a href="javascript:void(0)" id="resendMail" class="emailStatus" (click)="activateUser()"
      >Activate</a
    >
  </ng-container>
</ng-container>

<!-- Reviewer verification section -->
<ng-container
  *ngIf="
    params.roleCheck?.length == 0 &&
    params.from == 'reviewer' &&
    !params.data?.isReviewerVerified &&
    params.data.accessRoleName == commonEnum.reviewerName
  "
>
  <a href="javascript:void(0)" id="resendMail" class="emailStatus" (click)="reviewerVerified()"
    >Verify</a
  >
</ng-container>

<ng-container *ngIf="params.value && userFirstName && !isAdminOrganizationDetail">
  <a
    href="javascript:void(0)"
    id="resendMail"
    [title]="clickTooltipDef"
    [routerLink]="['details', encryptedUserId]"
    class="firstNameStatus"
    >{{ params.data.firstName }}</a
  >
</ng-container>

<ng-container *ngIf="params.value && teamName && !isAdminOrganizationDetail">
  <a
    href="javascript:void(0)"
    [title]="clickTooltipDef"
    id="resendMail"
    [routerLink]="['details', encryptedUserId]"
    class="emailStatus"
    >{{ params.data.name }}</a
  >
</ng-container>

<ng-container *ngIf="params.value && isNews && !isAdminOrganizationDetail">
  <a
    href="javascript:void(0)"
    [title]="clickTooltipDef"
    id="resendMail"
    [routerLink]="['details', encryptedUserId]"
    class="emailStatus"
    >{{ params.data.subject }}</a
  >
</ng-container>

<ng-container *ngIf="logEntry">
  <a
    href="javascript:void(0)"
    id="resendMail"
    (click)="projectRouting(params.data, 'newViewLogEntries')"
    class="firstNameStatus"
    >{{ params.data.tableName }}</a
  >
</ng-container>

<ng-container *ngIf="params.value && isAdminOrganizationDetail">
  <a
    href="javascript:void(0)"
    id="resendMail"
    [title]="clickTooltipDef"
    [routerLink]="['details', encryptedUserId]"
    class="firstNameStatus"
    >{{ params.data.name }}</a
  >
</ng-container>

<ng-container *ngIf="importsLink">
  <div *ngIf="!showFullContent" class="short-content">
    {{ stackTrace | slice : 0 : 50 }}{{ stackTrace?.length > 50 ? '...' : '' }}
    <span *ngIf="stackTrace?.length > 50" (click)="showFullContent = true" class="importlink-text"
      >See more</span
    >
  </div>
  <div *ngIf="showFullContent" class="full-content">
    {{ stackTrace }}
    <span (click)="showFullContent = false" class="importlink-text">See less</span>
  </div>
</ng-container>

<ng-container *ngIf="errorMessageLink">
  <div *ngIf="!showFullContentError" class="short-content">
    {{ errorMessage | slice : 0 : 50 }}{{ errorMessage?.length > 50 ? '...' : '' }}
    <span
      *ngIf="errorMessage?.length > 50"
      (click)="showFullContentError = true"
      class="importlink-text"
      >See more</span
    >
  </div>
  <div *ngIf="showFullContentError" class="full-content">
    {{ errorMessage }}
    <span (click)="showFullContentError = false" class="importlink-text">See less</span>
  </div>
</ng-container>
